import exact from 'prop-types-exact';
import PropTypes from 'prop-types';
import React from 'react';

import Button from '../Atoms/Button';

const propTypes = exact({
  editButtonText: PropTypes.string.isRequired,
  editMessage: PropTypes.string.isRequired,
  editURL: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
});

function ClientEditDetails(props) {
  return (
    <fieldset className="ClientEditDetails">
      <h2 className="ClientEditDetails_title">{props.title}</h2>
      <div className="ClientEditDetails_container">
        <div className="ClientEditDetails_content">{props.editMessage}</div>
        <div className="ClientEditDetails_button">
          <Button
            elementType="link"
            modifier="fill"
            text={props.editButtonText}
            url={props.editURL}
          />
        </div>
      </div>
    </fieldset>
  );
}

ClientEditDetails.propTypes = propTypes;

export default ClientEditDetails;
